export enum InvoiceStatus {
	None             = '',
	PerformingOcr    = 'performing_ocr',
	OcrFailed        = 'ocr_failed',
	New              = 'new',
	Accepted         = 'accepted',
	Refused          = 'refused',
	Annotated        = 'annotated',
	Billed           = 'billed',
	PaymentProcessed = 'payment_processed',
	Paid             = 'paid',
	Invalid          = 'invalid',
	Error            = 'error'
}
